import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import {
  addCity,
  deleteCity,
  getCities,
  getCountries,
  getDistricts,
  getStates,
  updateCity,
} from "../../Services/HomeService";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const ManageCity = () => {
  const [states, setStates] = useState([]);
  const [fetchStatesLoading, setFetchStatesLoading] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [fetchDistrictsLoading, setFetchDistrictsLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [fetchcitiesLoading, setFetchCitiesLoading] = useState(false);

  const [editCity, setEditCity] = useState(null);

  const [updateCityLoading, setUpdateCityLoading] = useState(false);

  const [createCityLoading, setCreateCityLoading] = useState(false);

  const [createCityObject, setCreateCityObject] = useState({
    countryId: "",
    stateId: "",
    districtId: "",
    cityName: "",
  });

  const [countries, setCountries] = useState([]);
  const [fetchCountriesLoading, setFetchCountriesLoading] = useState(false);

  const fetchCountries = async () => {
    try {
      setFetchCountriesLoading(true);
      const res = await getCountries();
      console.log("fetched counries", res);
      if (res?.status) {
        setCountries(res?.data);
        setFetchCountriesLoading(false);
      } else {
        toast.error("Error while Fetching Counries Data");
        setFetchCountriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Counries Data");
      console.error("Error fetching Counries:", error);
      setFetchCountriesLoading(false);
    }
  };

  const fetchCities = async () => {
    try {
      setFetchCitiesLoading(true);
      const res = await getCities();
      console.log("fetched Cities", res?.data);
      if (res?.status) {
        setCities(res?.data);
        setFetchCitiesLoading(false);
      } else {
        toast.error("Error while Fetching Cities Data");
        setFetchCitiesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Cities Data");
      console.error("Error fetching Districts:", error);
      setFetchCitiesLoading(false);
    }
  };

  const fetchDistricts = async () => {
    try {
      setFetchDistrictsLoading(true);
      const res = await getDistricts();
      console.log("fetched districts", res?.data);
      if (res?.status) {
        setDistricts(res?.data);
        setFetchDistrictsLoading(false);
      } else {
        toast.error("Error while Fetching Districts Data");
        setFetchDistrictsLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Districts Data");
      console.error("Error fetching Districts:", error);
      setFetchDistrictsLoading(false);
    }
  };

  const fetchStates = async (country) => {
    try {
      setFetchStatesLoading(true);
      const res = await getStates();
      console.log("fetched states", res);
      if (res?.status) {
        setStates(res?.data.filter((item) => item.country._id === country));
        setFetchStatesLoading(false);
      } else {
        toast.error("Error while Fetching States Data");
        setFetchStatesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch States Data");
      console.error("Error fetching State:", error);
      setFetchStatesLoading(false);
    }
  };

  useEffect(() => {
    fetchCountries();
    fetchStates();
    fetchDistricts();
    fetchCities();
  }, []);

  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };
  const customStyles = {
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        color: "#333",
      },
    },
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      center: true,
    },
    {
      name: "Country",
      selector: (row) => row.country?.countryName,
      sortable: true,
      center: true,
    },
    {
      name: "State Name",
      selector: (row) => row?.state?.stateName,
      sortable: true,
      center: true,
    },
    {
      name: "District Name",
      selector: (row) => row?.district?.districtName,
      sortable: true,
      center: true,
    },
    {
      name: "City Name",
      selector: (row) => row.cityName,
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <span title="Edit">
            <i
              onClick={() => {
                handleUpdateClick(row);
              }}
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          {/* <span title="Delete">
            <i
              onClick={() => {
                handleDelete(row?._id);
              }}
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span> */}
        </>
      ),
    },
  ];

  const handleCreateCity = async (e) => {
    e?.preventDefault();
    if (
      !createCityObject?.districtId ||
      !createCityObject?.stateId ||
      !createCityObject?.cityName
    ) {
      toast.error("Please Enter All Fields");
      return;
    }
    try {
      setCreateCityLoading(true);
      const res = await addCity(createCityObject);
      console.log("City Add Message", res);
      if (res?.status) {
        toast.success(res?.message);

        setCreateCityObject((prev) => ({ ...prev, cityName: "" }));

        fetchCities();
        setCreateCityLoading(false);
      } else {
        toast.error(res?.message);
        setCreateCityLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add City.");
      console.error("Error adding City:", error);
      setCreateCityLoading(false);
    }
  };

  const handleUpdateClick = (row) => {
    setEditCity(row);
    fetchStates(row?.country._id);
    // setEditCity({
    //   countryId: row?.country._id,
    //   stateId: row?.state._id,
    //   districtId: row?.district._id,
    //   cityName: row.cityName,
    // })
    console.log("POI246", row);
  };

  const handleCancel = () => {
    setEditCity(null);
  };

  const handleUpdateCity = async (e) => {
    e?.preventDefault();
    if (
      !editCity?.cityName ||
      !editCity?.state?._id ||
      !editCity?.district?._id
    ) {
      return toast.error("Enter All Fields to Update");
    }

    try {
      setUpdateCityLoading(true);
      const res = await updateCity(editCity?._id, {
        countryId: editCity?.country?._id,
        stateId: editCity?.state?._id,
        districtId: editCity?.district?._id,
        cityName: editCity?.cityName,
      });
      console.log("City update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setEditCity(null);
        fetchCities();
        setUpdateCityLoading(false);
      } else {
        toast.error(res?.message);
        setUpdateCityLoading(false);
      }
    } catch (error) {
      toast.error("Failed to Update City.");
      console.error("Error Updating City:", error);
      setUpdateCityLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete City?",
      text: "Are you sure you want to delete this City?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await deleteCity(id);
        Swal.fire("Deleted!", "City has been deleted.", "success");
        fetchCities();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete City.", "error");
      }
    }
  };

  // these 2 veriables are crusial. It maintains the "No District Found" message in create and update City
  let a = false;
  let b = false;

  useEffect(() => {
    fetchStates(createCityObject?.countryId);
  }, [createCityObject?.countryId]);

  useEffect(() => {
    fetchStates(editCity?.country._id);
  }, [editCity?.country._id]);

  return (
    <>
      {!editCity && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Manage City
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleCreateCity(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Country<span className="text-danger">*</span>
                    </label>
                    <select
                      required
                      className="form-control"
                      onChange={(e) => {
                        setCreateCityObject((prev) => ({
                          ...prev,
                          countryId: e?.target?.value,
                        }));
                      }}
                      value={createCityObject?.countryId}
                    >
                      <option value="">-------- Select Country --------</option>
                      {fetchCountriesLoading ? (
                        <option>Loading...</option>
                      ) : countries?.length === 0 ? (
                        <option disabled>No Country Found</option>
                      ) : (
                        countries?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.countryName}
                            </option>
                          );
                        })
                      )}
                    </select>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      State Name<span className="text-danger">*</span>
                    </label>
                    <select
                      required
                      className="form-control"
                      onChange={(e) => {
                        setCreateCityObject((prev) => ({
                          ...prev,
                          stateId: e?.target?.value,
                        }));
                      }}
                    >
                      <option value="">-------- Select State --------</option>
                      {fetchStatesLoading ? (
                        <option>Loading...</option>
                      ) : states?.length === 0 ? (
                        <option disabled>No State Found</option>
                      ) : (
                        states?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.stateName}
                            </option>
                          );
                        })
                      )}

                      {/* <option value="">Orisa</option>
                    <option value="">Delhi</option>
                    <option value="">Bihar</option> */}
                    </select>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      District Name<span className="text-danger">*</span>
                    </label>

                    <select
                      required
                      disabled={!createCityObject?.stateId}
                      className="form-control"
                      onChange={(e) => {
                        setCreateCityObject((prev) => ({
                          ...prev,
                          districtId: e?.target?.value,
                        }));
                      }}
                    >
                      <option value="">
                        -------- Select District --------
                      </option>
                      {fetchDistrictsLoading ? (
                        <option>Loading...</option>
                      ) : districts?.length === 0 ? (
                        <option disabled>No District Found</option>
                      ) : (
                        districts?.map((e, i) => {
                          if (e?.state?._id === createCityObject?.stateId) {
                            a = true;
                            return (
                              <option key={i} value={e?._id}>
                                {e?.districtName}
                              </option>
                            );
                          }
                        })
                      )}
                      {!a && <option disabled>No District found</option>}
                      {/* <option value="">North 24 Parganas</option>
                    <option value="">Kolkata</option>
                    <option value="">Siliguri</option>
                    <option value="">Purulia</option> */}
                    </select>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      City Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      value={createCityObject?.cityName}
                      onChange={(e) =>
                        setCreateCityObject((prev) => ({
                          ...prev,
                          cityName: e?.target?.value,
                        }))
                      }
                      placeholder="Enter City Name"
                      required
                    />
                  </div>
                </div>
                <div className=" d-flex justify-content-center">
                  <button
                    disabled={createCityLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {createCityLoading ? "Loading..." : "Add City"}
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
      {!editCity && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <section className="chartBox_area">
              <DataTable
                data={cities}
                columns={columns}
                pagination
                responsive
                highlightOnHover
                customStyles={customStyles}
                progressPending={fetchcitiesLoading}
              />
            </section>
          </div>
        </div>
      )}
      {editCity && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Update City
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleUpdateCity(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Country<span className="text-danger">*</span>
                    </label>
                    <select
                      required
                      className="form-control"
                      onChange={(e) => {
                        setEditCity((prev) => ({
                          ...prev,
                          country: {
                            ...prev?.country,
                            _id: e?.target?.value,
                          },
                        }));
                      }}
                      value={editCity?.country?._id}
                    >
                      <option value="">-------- Select Country --------</option>
                      {fetchCountriesLoading ? (
                        <option>Loading...</option>
                      ) : countries?.length === 0 ? (
                        <option disabled>No Country Found</option>
                      ) : (
                        countries?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.countryName}
                            </option>
                          );
                        })
                      )}
                    </select>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      State Name<span className="text-danger">*</span>
                    </label>
                    <select
                      value={editCity?.state?._id}
                      required
                      className="form-control"
                      onChange={(e) => {
                        // setCreateCityObject((prev) => ({
                        //   ...prev,
                        //   stateId: e?.target?.value,
                        // }));
                        setEditCity((prev) => ({
                          ...prev,
                          state: { ...prev?.state, _id: e?.target?.value },
                        }));
                      }}
                    >
                      <option value="">-------- Select State --------</option>
                      {fetchStatesLoading ? (
                        <option>Loading...</option>
                      ) : states?.length === 0 ? (
                        <option disabled>No State Found</option>
                      ) : (
                        states?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.stateName}
                            </option>
                          );
                        })
                      )}

                      {/* <option value="">Orisa</option>
                    <option value="">Delhi</option>
                    <option value="">Bihar</option> */}
                    </select>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      District Name<span className="text-danger">*</span>
                    </label>

                    <select
                      value={editCity?.district?._id}
                      required
                      className="form-control"
                      onChange={(e) => {
                        // setCreateCityObject((prev) => ({
                        //   ...prev,
                        //   districtId: e?.target?.value,
                        // }));
                        setEditCity((prev) => ({
                          ...prev,
                          district: {
                            ...prev?.district,
                            _id: e?.target?.value,
                          },
                        }));
                      }}
                    >
                      <option value="">
                        -------- Select District --------
                      </option>
                      {fetchDistrictsLoading ? (
                        <option>Loading...</option>
                      ) : districts?.length === 0 ? (
                        <option disabled>No District Found</option>
                      ) : (
                        districts?.map((e, i) => {
                          // if (e?.state?._id === createCityObject?.stateId) {
                          if (e?.state?._id === editCity?.state?._id) {
                            b = true;
                            return (
                              <option value={e?._id}>{e?.districtName}</option>
                            );
                          }
                        })
                      )}
                      {!b && <option disabled>No District found</option>}
                      {/* <option value="">North 24 Parganas</option>
                    <option value="">Kolkata</option>
                    <option value="">Siliguri</option>
                    <option value="">Purulia</option> */}
                    </select>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      City Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      value={editCity?.cityName}
                      onChange={(e) =>
                        // setCreateCityObject((prev) => ({
                        //   ...prev,
                        //   cityName: e?.target?.value,
                        // }))
                        {
                          setEditCity((prev) => ({
                            ...prev,
                            cityName: e?.target?.value,
                          }));
                        }
                      }
                      placeholder="Enter City Name"
                      required
                    />
                  </div>
                </div>
                <div
                  className=" d-flex justify-content-center"
                  style={{ gap: "15px" }}
                >
                  <button
                    disabled={updateCityLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {updateCityLoading ? "Loading..." : "Update"}
                  </button>
                  <button
                    onClick={() => {
                      handleCancel();
                    }}
                    disabled={updateCityLoading}
                    type="button"
                    className="btn mt-3"
                    style={{
                      background: "#f77754",
                      borderRadius: "13px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default ManageCity;
